import React from "react";
import { Link } from "react-router-dom";
import AddressModifier from "./AddressModifier";
import RecapCard from "./RecapCard";
import RecapCompanyInfos from "./RecapCompanyInfos";

const CompanyTopRecap = ({ company }) => {
  return (
    <RecapCard>
      <RecapCompanyInfos company={company} companyType={company.type} />
      <AddressModifier company={company} />
    </RecapCard>
  );
};

export default CompanyTopRecap;
